import { render, staticRenderFns } from "./SessionExpiredPage.vue?vue&type=template&id=bdb75534"
import script from "./SessionExpiredPage.vue?vue&type=script&lang=ts"
export * from "./SessionExpiredPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports